import React from 'react';

export const PlusCircleIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="30" height="30" rx="15" fill="#055DF5" />
        <rect x="1" y="1" width="30" height="30" rx="15" stroke="#055DF5" strokeWidth="2" />
        <path d="M10 16L22 16" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16 10L16 22" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const MinusCircleIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="30" height="30" rx="15" fill="#055DF5" />
        <rect x="1" y="1" width="30" height="30" rx="15" stroke="#055DF5" strokeWidth="2" />
        <path d="M10 16L22 16" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const BillingPaymentIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="36" viewBox="0 0 44 36" fill="none">
        <path
            d="M30.9522 2H5.0476C3.36446 2 2 3.36447 2 5.0476V23.3332C2 25.0164 3.36446 26.3808 5.0476 26.3808H30.9522C32.6354 26.3808 33.9998 25.0164 33.9998 23.3332V5.0476C33.9998 3.36447 32.6354 2 30.9522 2Z"
            stroke="#545556"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.144 33.9995H38.5725C39.3807 33.9995 40.156 33.6783 40.7274 33.1069C41.2989 32.5354 41.6201 31.7601 41.6201 30.9519V15.7139"
            stroke="#545556"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.17206 14.5155C7.75127 14.5155 7.41016 14.1744 7.41016 13.7536C7.41016 13.3328 7.75127 12.9917 8.17206 12.9917"
            stroke="#545556"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.17383 14.5155C8.59461 14.5155 8.93573 14.1744 8.93573 13.7536C8.93573 13.3328 8.59461 12.9917 8.17383 12.9917"
            stroke="#545556"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M27.8283 14.516C27.4075 14.516 27.0664 14.1749 27.0664 13.7541C27.0664 13.3333 27.4075 12.9922 27.8283 12.9922"
            stroke="#545556"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M27.8301 14.516C28.2509 14.516 28.592 14.1749 28.592 13.7541C28.592 13.3333 28.2509 12.9922 27.8301 12.9922"
            stroke="#545556"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M17.999 17.9999C20.1029 17.9999 21.8085 16.2943 21.8085 14.1904C21.8085 12.0864 20.1029 10.3809 17.999 10.3809C15.895 10.3809 14.1895 12.0864 14.1895 14.1904C14.1895 16.2943 15.895 17.9999 17.999 17.9999Z"
            stroke="#545556"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const CollapseArrowsIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
        <path d="M1 21.7745L8.69233 14.1162" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2.53906 14.1162H8.69293V20.2428" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M21.0007 1.86328L13.3083 9.52157" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M19.462 9.52117H13.3081V3.39453" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const ExpandArrowsIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
        <path d="M8.69263 14.1161L1.0003 21.7744" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.15356 21.7744L0.9997 21.7744L0.999701 15.6478" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M13.3082 9.52148L21.0005 1.86319" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14.8469 1.8636L21.0007 1.8636L21.0007 7.99023" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const EditIcon = ({ iconWidth = '19', iconHeight = '18', fill = 'none' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={iconWidth} height={iconHeight} viewBox="0 0 19 18" fill={fill}>
        <path d="M9.1885 3.45703H3V16.4957H16.0387V10.8002" stroke="#545556" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M14.2486 2.12093L9.81157 7.15477L9.2018 10.022C9.09801 10.4761 9.57804 10.9172 10.0321 10.7745L12.8734 9.87927L17.4531 5.05301C18.2186 4.24864 18.0759 2.91234 17.1547 2.09499C16.2595 1.30358 14.9492 1.30358 14.2356 2.12093H14.2486Z"
            stroke="#545556"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const SearchIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path
            d="M5.23077 9.46154C6.35284 9.46154 7.42895 9.0158 8.22238 8.22238C9.0158 7.42895 9.46154 6.35284 9.46154 5.23077C9.46154 4.1087 9.0158 3.03259 8.22238 2.23916C7.42895 1.44574 6.35284 1 5.23077 1C4.1087 1 3.03259 1.44574 2.23916 2.23916C1.44574 3.03259 1 4.1087 1 5.23077C1 6.35284 1.44574 7.42895 2.23916 8.22238C3.03259 9.0158 4.1087 9.46154 5.23077 9.46154Z"
            stroke="#1B1C1D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M10.9999 10.9999L8.30762 8.30762" stroke="#1B1C1D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const ExportIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none">
        <path
            d="M11.1508 12.0754C11.1508 12.3239 11.0514 12.5526 10.8824 12.7316C10.7133 12.9105 10.4747 13 10.2262 13H1.92461C1.67606 13 1.44739 12.9006 1.26843 12.7316C1.09942 12.5626 1 12.3239 1 12.0754V1.92461C1 1.67606 1.09942 1.44739 1.26843 1.26843C1.43745 1.09942 1.67606 1 1.92461 1H7.92958L11.1607 4.23115V12.0754H11.1508Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M7.92011 7.91943L6.07089 9.76865L4.22168 7.91943" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.08105 9.76835V4.68799" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const AddIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path
            d="M7.16016 12.9901C10.4681 12.9901 13.1602 10.3079 13.1602 6.99007C13.1602 3.67219 10.4681 1 7.16016 1C3.85221 1 1.16016 3.68212 1.16016 7C1.16016 10.3179 3.84228 13 7.16016 13V12.9901Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M7.16016 4.22803V9.76114" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.3877 7H9.92081" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const SaveIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
        <path
            d="M4.5 8.03147L5.48533 9.3011C5.52038 9.34395 5.56322 9.379 5.60995 9.40236C5.66058 9.42573 5.71121 9.44131 5.76574 9.44131C5.82026 9.44131 5.87089 9.42963 5.92152 9.40626C5.97215 9.38289 6.01499 9.35173 6.04615 9.30889L9.20075 5.5"
            stroke="#055DF5"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7 13.4901C10.3079 13.4901 13 10.8079 13 7.49007C13 4.17219 10.3079 1.5 7 1.5C3.69205 1.5 1 4.18212 1 7.5C1 10.8179 3.68212 13.5 7 13.5V13.4901Z"
            stroke="#055DF5"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const CancelIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
        <path
            d="M7 13.4901C10.3079 13.4901 13 10.8079 13 7.49007C13 4.17219 10.3079 1.5 7 1.5C3.69205 1.5 1 4.18212 1 7.5C1 10.8179 3.68212 13.5 7 13.5V13.4901Z"
            stroke="#F00024"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M5.04199 5.53418L8.95449 9.44668" stroke="#F00024" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.04199 9.45459L8.95449 5.54209" stroke="#F00024" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const HelpCircleIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path
            d="M7 13C8.5913 13 10.1174 12.3679 11.2426 11.2426C12.3679 10.1174 13 8.5913 13 7C13 5.4087 12.3679 3.88258 11.2426 2.75736C10.1174 1.63214 8.5913 1 7 1C5.4087 1 3.88258 1.63214 2.75736 2.75736C1.63214 3.88258 1 5.4087 1 7C1 8.5913 1.63214 10.1174 2.75736 11.2426C3.88258 12.3679 5.4087 13 7 13Z"
            fill="#055DF5"
            stroke="#055DF5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.38477 5.38477C5.38447 5.14566 5.43729 4.90947 5.53941 4.69326C5.64153 4.47706 5.7904 4.28623 5.97527 4.13458C6.16013 3.98292 6.37637 3.87423 6.60837 3.81634C6.84037 3.75845 7.08233 3.75282 7.31677 3.79985C7.55111 3.84654 7.77219 3.94457 7.96411 4.08691C8.15604 4.22924 8.31404 4.41234 8.42676 4.62302C8.53947 4.83371 8.6041 5.06676 8.61599 5.30541C8.62788 5.54406 8.58675 5.78238 8.49554 6.00323C8.37316 6.29853 8.16592 6.55088 7.90005 6.72834C7.63419 6.9058 7.32165 7.0004 7.002 7.00015V8.07738"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <circle cx="7.02539" cy="9.82495" r="0.5" fill="white" stroke="white" strokeWidth="0.25" />
    </svg>
);

export const FilterCircleIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M13 1H1L5.61538 7.46154V13L8.38462 11.1538V7.46154L13 1Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const DeleteIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
        <path d="M0.96875 3.5332H11.1212" stroke="#F00024" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M2.23535 3.5332H9.85424V11.1521C9.85424 11.3799 9.76311 11.5895 9.60818 11.7536C9.45325 11.9176 9.23452 11.9996 9.00669 11.9996H3.08291C2.85507 11.9996 2.64546 11.9085 2.48142 11.7536C2.32649 11.5987 2.23535 11.3799 2.23535 11.1521V3.5332Z"
            stroke="#F00024"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.93066 3.53355V3.11433C3.93066 2.5493 4.14939 2.0116 4.55038 1.61972C4.95138 1.21872 5.48907 1 6.045 1C6.60092 1 7.14773 1.21872 7.53961 1.61972C7.94061 2.02071 8.15933 2.55841 8.15933 3.11433V3.53355"
            stroke="#F00024"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M4.77832 6.06738V9.45761" stroke="#F00024" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.31152 6.06738V9.45761" stroke="#F00024" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const EyeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none">
        <path
            d="M14.6107 5.01371C14.7836 5.23285 14.8873 5.5212 14.8873 5.82107C14.8873 6.12095 14.7836 6.40929 14.6107 6.62843C13.4813 7.9894 10.9343 10.6421 7.9379 10.6421C4.94146 10.6421 2.39449 7.9894 1.27659 6.62843C1.10372 6.40929 1 6.12095 1 5.82107C1 5.5212 1.10372 5.23285 1.27659 5.01371C2.39449 3.65274 4.95299 1 7.9379 1C10.9228 1 13.4813 3.65274 14.6107 5.01371Z"
            stroke="#545556"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.94048 7.9663C9.12753 7.9663 10.0841 7.00901 10.0841 5.82104C10.0841 4.63308 9.12753 3.67578 7.94048 3.67578C6.75343 3.67578 5.79688 4.63308 5.79688 5.82104C5.79688 7.00901 6.75343 7.9663 7.94048 7.9663Z"
            stroke="#545556"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const BarSpeedTestIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13" fill="none">
        <path
            d="M11.3335 11.6668H13.3595C13.7645 11.6668 14.1585 11.4871 14.3412 11.1258C14.7805 10.2564 15.0002 9.0351 15.0002 8.00009C15.0002 4.13404 11.8661 1 8.00009 1C4.13404 1 1 4.13404 1 8.00009C1 9.0351 1.21967 10.2568 1.65901 11.1258C1.84168 11.4868 2.23568 11.6668 2.64102 11.6668H4.66671"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.06335 10.7413C7.02937 10.8681 7.02071 11.0004 7.03786 11.1306C7.05502 11.2608 7.09764 11.3864 7.16331 11.5001C7.22898 11.6138 7.31641 11.7135 7.4206 11.7934C7.52479 11.8733 7.64371 11.932 7.77056 11.9659C8.02674 12.0346 8.2997 11.9986 8.52937 11.866C8.64309 11.8003 8.74277 11.7129 8.8227 11.6087C8.90264 11.5045 8.96126 11.3856 8.99524 11.2587C9.06386 11.0026 9.02791 10.7296 8.89528 10.4999C8.76265 10.2703 8.54422 10.1027 8.28803 10.0341C8.03185 9.96543 7.75889 10.0014 7.52922 10.134C7.29955 10.2666 7.13197 10.4851 7.06335 10.7413Z"
            fill="white"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M8.34521 9.71241L9.5925 5.80469" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const MoneyBillIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
        <path
            d="M2.00549 2.50781C1.73882 2.50781 1.48307 2.61375 1.2945 2.80231C1.10594 2.99088 1 3.24663 1 3.51331V13.0655C1 13.3322 1.10594 13.588 1.2945 13.7765C1.48307 13.965 1.73882 14.071 2.00549 14.071H13.0659C13.3326 14.071 13.5884 13.965 13.7769 13.7765C13.9654 13.588 14.0714 13.3322 14.0714 13.0655V3.51331C14.0714 3.24663 13.9654 2.99088 13.7769 2.80231C13.5884 2.61375 13.3326 2.50781 13.0659 2.50781H11.0549"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M1 6.02734H14.0714" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.01636 1V4.01648" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.0548 1V4.01648" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.01636 2.50781H9.04383" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const LayoutWindowIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            d="M13.9231 1H2.07692C1.48215 1 1 1.48215 1 2.07692V13.9231C1 14.5179 1.48215 15 2.07692 15H13.9231C14.5179 15 15 14.5179 15 13.9231V2.07692C15 1.48215 14.5179 1 13.9231 1Z"
            stroke="white"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M1 4.23047H15" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.99988 4.23047V14.9997" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M1 9.61572H15" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const EmptyFileIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
        <path
            d="M13 14.0909C13 14.3802 12.885 14.6577 12.6805 14.8623C12.4759 15.0668 12.1984 15.1818 11.9091 15.1818H2.09091C1.80158 15.1818 1.52411 15.0668 1.31952 14.8623C1.11494 14.6577 1 14.3802 1 14.0909V2.09091C1 1.80158 1.11494 1.52411 1.31952 1.31952C1.52411 1.11493 1.80158 1 2.09091 1H9.18182L13 4.81818V14.0909Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M8.63635 1V5.36364H13" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const GraphDotIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M1.00024 1V14.9997H15" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M5.33663 4.53662C6.41658 4.53662 7.29204 5.41209 7.29204 6.49203C7.29204 7.57198 6.41658 8.44744 5.33663 8.44744C4.25668 8.44744 3.38123 7.57198 3.38123 6.49203C3.38123 5.41209 4.25668 4.53662 5.33663 4.53662Z"
            stroke="white"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.0447 1.26758C14.1245 1.26758 15 2.14305 15 3.22299C15 4.30293 14.1245 5.1784 13.0447 5.1784C11.9647 5.1784 11.0892 4.30293 11.0892 3.22299C11.0892 2.14305 11.9647 1.26758 13.0447 1.26758Z"
            stroke="white"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.3265 8.44727C11.4064 8.44727 12.2819 9.32273 12.2819 10.4027C12.2819 11.4826 11.4064 12.3581 10.3265 12.3581C9.24655 12.3581 8.37109 11.4826 8.37109 10.4027C8.37109 9.32273 9.24655 8.44727 10.3265 8.44727Z"
            stroke="white"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M1 10.6688L3.79037 7.68896" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.04187 7.46631L8.83115 9.13516" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.1879 8.63642L12.4782 5.09229" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const WarningTriangleIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            d="M8.95892 1.58616C8.8685 1.40968 8.73113 1.26157 8.56194 1.15815C8.39275 1.05472 8.1983 1 8.00001 1C7.80171 1 7.60726 1.05472 7.43807 1.15815C7.26888 1.26157 7.13151 1.40968 7.0411 1.58616L1.11526 13.4378C1.03261 13.6018 0.993258 13.7842 1.00094 13.9678C1.00863 14.1513 1.0631 14.3297 1.15918 14.4863C1.25525 14.6428 1.38975 14.7722 1.54989 14.8621C1.71003 14.9521 1.8905 14.9996 2.07417 15.0001H13.9258C14.1095 14.9996 14.29 14.9521 14.4501 14.8621C14.6103 14.7722 14.7448 14.6428 14.8409 14.4863C14.9369 14.3297 14.9914 14.1513 14.999 13.9678C15.0068 13.7842 14.9674 13.6018 14.8847 13.4378L8.95892 1.58616Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M7.99976 5.84229V9.34392" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M8.00007 12.3068C7.85131 12.3068 7.73071 12.1862 7.73071 12.0374C7.73071 11.8886 7.85131 11.7681 8.00007 11.7681"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8 12.3068C8.14876 12.3068 8.26936 12.1862 8.26936 12.0374C8.26936 11.8886 8.14876 11.7681 8 11.7681"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const UserCircleIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
        <path
            d="M3.13477 11.6084C3.55832 10.974 4.13293 10.4538 4.80741 10.0941C5.48188 9.73439 6.23526 9.5464 7.00041 9.54688C8.61334 9.54688 10.0341 10.366 10.867 11.6084"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.99944 8.16008C7.27381 8.16008 7.54549 8.10628 7.79898 8.00175C8.05246 7.89722 8.28278 7.744 8.47679 7.55085C8.6708 7.3577 8.82469 7.1284 8.92969 6.87604C9.03469 6.62368 9.08873 6.3532 9.08873 6.08004C9.08873 5.80689 9.03469 5.53641 8.92969 5.28404C8.82469 5.03168 8.6708 4.80238 8.47679 4.60923C8.28278 4.41608 8.05246 4.26287 7.79898 4.15833C7.54549 4.0538 7.27381 4 6.99944 4C6.44533 4 5.91391 4.21915 5.52209 4.60923C5.13028 4.99931 4.91016 5.52838 4.91016 6.08004C4.91016 6.6317 5.13028 7.16077 5.52209 7.55085C5.91391 7.94094 6.44533 8.16008 6.99944 8.16008Z"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <circle cx="7" cy="7.02734" r="6.5" stroke="white" />
    </svg>
);
export const PlusCircle = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="30" height="30" rx="15" fill="#055DF5" />
        <rect x="1" y="1" width="30" height="30" rx="15" stroke="#055DF5" strokeWidth="2" />
        <path d="M10 16L22 16" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16 10L16 22" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
export const MinusCircle = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="30" height="30" rx="15" fill="#055DF5" />
        <rect x="1" y="1" width="30" height="30" rx="15" stroke="#055DF5" strokeWidth="2" />
        <path d="M10 16L22 16" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
